module.exports = __webpack_public_path__ + "img/youting.93d995f7.gif";